import { render, staticRenderFns } from "./test-plane.vue?vue&type=template&id=30b536a8&scoped=true"
import script from "./test-plane.vue?vue&type=script&lang=js"
export * from "./test-plane.vue?vue&type=script&lang=js"
import style0 from "./test-plane.vue?vue&type=style&index=0&id=30b536a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b536a8",
  null
  
)

export default component.exports